/**
 * Initialize HLS Video Player
 */
import Hls from 'hls.js';

function InitVideoPlayer() {
    // Find all video elements that need HLS support
    const videoElements = document.querySelectorAll('.page-video, .front-page-header-video');

    if (videoElements.length === 0) {
        return;
    }

    videoElements.forEach((videoElement) => {
        initSingleVideoPlayer(videoElement);
    });
}

function initSingleVideoPlayer(videoElement) {
    const fallbackImage = videoElement.parentElement.querySelector('.fallback-image, .header-fallback-image');
    const source = videoElement.querySelector('source');

    if (!source) {
        console.log('No video source found');
        return;
    }

    const videoSrc = source.src;

    // Hide video initially, show fallback image
    videoElement.style.opacity = '0';
    if (fallbackImage) {
        fallbackImage.style.opacity = '1';
    }

    if (Hls.isSupported()) {
        const hls = new Hls({
            autoStartLoad: true,
            startLevel: 4, // Start with lowest quality for faster loading
            capLevelToPlayerSize: true,
            maxBufferLength: 10, // Reduce buffer size for faster start
        });

        hls.loadSource(videoSrc);
        hls.attachMedia(videoElement);

        hls.on(Hls.Events.MANIFEST_PARSED, function() {
            videoElement.play().catch(e => {
                console.log('Video autoplay failed:', e);
            });
        });

        // Show video when it starts playing
        videoElement.addEventListener('playing', function() {
            videoElement.style.opacity = '1';
            if (fallbackImage) {
                fallbackImage.style.opacity = '0';
            }
        });

        hls.on(Hls.Events.ERROR, function(event, data) {
            if (data.fatal) {
                console.error('Fatal HLS error:', data);
                videoElement.style.opacity = '0';
                if (fallbackImage) {
                    fallbackImage.style.opacity = '1';
                }
            }
        });
    } else if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
        // Native HLS support (Safari)
        videoElement.src = videoSrc;

        videoElement.addEventListener('playing', function() {
            videoElement.style.opacity = '1';
            if (fallbackImage) {
                fallbackImage.style.opacity = '0';
            }
        });

        videoElement.play().catch(e => {
            console.log('Video autoplay failed:', e);
        });
    }
}

export default InitVideoPlayer;
